
function getType(objType) {
	return Object.prototype.toString.call(objType).slice(8, -1).toLocaleLowerCase();
}

/**
 * This function will check up the inheritance chain, a better typeof
 * @example
	$_GP._.is('number', 33) // true
	$_GP._.is('number', '33') // false
	$_GP._.is('number', NaN) // false
 * @param {string} str - name to test
 * @param {*} objType - any js object
 * @returns {boolean}
**/
function is(str, objType) {
	// TODO
	// is('nan', NaN)
	// is('nil', null) > null || undefined

	const types  = 'array object string date regexp function boolean number null undefined symbol'.split(' ')
	const validStr = types.some(t=> str === t)

	if (!validStr) {
		console.error('Error: first argument is not a valid data type.')
		return;
	}

	const type = getType(objType);

	if (str === 'number' && type === 'number') {
		return objType === objType
	}

	return str === type
}

function debounce(fn, wait) {

	wait = wait || 250;

	var timeout;
	return function () {
		const context = this;
		const args = arguments;

		var later = function () {
			timeout = null;
			fn.apply(context, args);
		};

		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
	};
}

function throttle(fn, timeWindow, scope) {

	timeWindow = timeWindow || (timeWindow = 200);
	var last, deferTimer;

	return function() {
		var context = scope || this;
		var now = new Date().getTime();
		var args = arguments;

		if (last && now < last + timeWindow) {
			clearTimeout(deferTimer);
			deferTimer = setTimeout(function() {
				last = now;
				fn.apply(context, args);
			}, timeWindow);
		}
		else {
			last = now;
			fn.apply(context, args);
		}
	};
}

function timeout(cb, time=300) {
	const st = window.setTimeout(() => {
		cb()
		window.clearTimeout(st)
	}, time);

	return st
}

function sleep(ms) {
	return new Promise((r) => setTimeout(r, ms))
}


export { is, getType, debounce, throttle, timeout, sleep }

